import React, { useContext, useState, useEffect } from 'react'
import { Formik, Form } from 'formik'
import $ from 'jquery'
import QuoteActionLinks from '../../QuoteActionLinks'
import QuoteModals from '../../QuoteModals'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCartPlus } from '@fortawesome/free-solid-svg-icons'
import { AppContext } from '../../../App'
import { CustomToggleShoppingCart } from './resinousFormInputs'
import config from '../../../config.json'
import axios from 'axios'
import toastNotify from '../../../services/toastNotify'
import Loading from '../../loading'
import ResinousAddToCartModal from './ResinousAddToCartModal'

export default function ResinousQuoteCreated() {
   const { 
      coverageDetails,
      calculatedProducts:calculatedProductsRaw,
      productOptionsSelected,
      selectedChip,
       selectedColor,
       colorSku,
       colorChipSku,
       colorCoverage,
       colorChipCoverage,
       unit,
       bu,
       iso,
       availableSmallColors,
       availableSmallMvbColors,
       availableSmallVaporBanColors,
       availableLargeMvbColors
   } = useContext(AppContext)

   const {
      clinicalPlus,
      extraTopCoat,
      preferredPackagingSize,
      substratePreparation,
      totalArea,
      tractionAdditive,
      vaporBarrier
   } = coverageDetails.formData

   const [tractionAdditiveData, setTractionAdditiveData] = useState()
    const [addToCartError, setAddToCartError] = useState(false)

    //temp code to cover us with the use of both large/small universal pigment skus on a large unit. New size coming will fix this
    let mvbKitCoverage = calculatedProductsRaw.map(c => {
        return (c.sku.indexOf("9220-0006-2") > -1) && c 
    }).filter(Boolean)

    let largeColorRequiredAmount = calculatedProductsRaw.map(c => {
        return (c.productName == "SPARTACOTE Universal Pigments" && c.unitForDisplayOnly.toLowerCase() == "large" && c.addOnMvb == "yes") && c.actualUnitsRequiredDefault
    }).filter(Boolean)

    let smallColorSku
    
    if (vaporBarrier) {
        if (vaporBarrier === "Spartacote MVB") {
            smallColorSku = availableSmallMvbColors.map(c => {
                return (c.Name.indexOf(selectedColor) > -1) && c.Sku 
            }).filter(Boolean)
        } else {
            smallColorSku = availableSmallVaporBanColors.map(c => {
                return (c.Name.indexOf(selectedColor) > -1) && c.Sku 
            }).filter(Boolean)
        }
    } else {
        smallColorSku = availableSmallColors.map(c => {
            return (c.Name.indexOf(selectedColor) > -1) && c.Sku 
        }).filter(Boolean)
    }
//end temp code

   // Adjust calculatedProducts(Raw) coming in from API calculation for correct preferred packaging size.
   // Add all products that are of the correct packaging Size, for BY LAYERS view
   let calculatedProductsForLayersPreflight = calculatedProductsRaw.map(cp => {
      return (cp.unitSize.toLowerCase().indexOf(preferredPackagingSize.toLowerCase()) > -1) && cp
   }).filter(Boolean)

   let calculatedProductsForLayersView = [];
   calculatedProductsForLayersPreflight.forEach((cppp, index) => {
      if (index === 0) {
         calculatedProductsForLayersView.push({ ...cppp });
      } else {
         const isExist = calculatedProductsForLayersView.findIndex(
            (el, ind) =>
                 el.productName === cppp.productName && el.layerNumber === cppp.layerNumber && el.unitForDisplayOnly === cppp.unitForDisplayOnly
         )
         if (isExist !== -1) {
            calculatedProductsForLayersView[isExist].actualUnitsRequiredDefault = calculatedProductsForLayersView[isExist].actualUnitsRequiredDefault + cppp.actualUnitsRequiredDefault
            calculatedProductsForLayersView[isExist].actualCsp1UnitsRequired = calculatedProductsForLayersView[isExist].actualCsp1UnitsRequired + cppp.actualCsp1UnitsRequired
            calculatedProductsForLayersView[isExist].actualCsp2UnitsRequired = calculatedProductsForLayersView[isExist].actualCsp2UnitsRequired + cppp.actualCsp2UnitsRequired
            calculatedProductsForLayersView[isExist].actualCsp3UnitsRequired = calculatedProductsForLayersView[isExist].actualCsp3UnitsRequired + cppp.actualCsp3UnitsRequired
            calculatedProductsForLayersView[isExist].actualCsp4UnitsRequired = calculatedProductsForLayersView[isExist].actualCsp4UnitsRequired + cppp.actualCsp4UnitsRequired
            calculatedProductsForLayersView[isExist].actualCsp5UnitsRequired = calculatedProductsForLayersView[isExist].actualCsp5UnitsRequired + cppp.actualCsp5UnitsRequired
            calculatedProductsForLayersView[isExist].unitsRequiredDefault = calculatedProductsForLayersView[isExist].unitsRequiredDefault + cppp.unitsRequiredDefault
            calculatedProductsForLayersView[isExist].csp1UnitsRequired = calculatedProductsForLayersView[isExist].csp1UnitsRequired + cppp.csp1UnitsRequired
            calculatedProductsForLayersView[isExist].csp2UnitsRequired = calculatedProductsForLayersView[isExist].csp2UnitsRequired + cppp.csp2UnitsRequired
            calculatedProductsForLayersView[isExist].csp3UnitsRequired = calculatedProductsForLayersView[isExist].csp3UnitsRequired + cppp.csp3UnitsRequired
            calculatedProductsForLayersView[isExist].csp4UnitsRequired = calculatedProductsForLayersView[isExist].csp4UnitsRequired + cppp.csp4UnitsRequired
            calculatedProductsForLayersView[isExist].csp5UnitsRequired = calculatedProductsForLayersView[isExist].csp5UnitsRequired + cppp.csp5UnitsRequired
         } else {
            calculatedProductsForLayersView.push({ ...cppp })
         }
      }
   });

   // Add all products that are of the correct packaging Size, for BY PRODUCTS view
   let calculatedProductsForProductsPreflight = calculatedProductsRaw.map((cp, index) => {
      return (cp.unitSize.toLowerCase().indexOf(preferredPackagingSize.toLowerCase()) > -1) && cp // Add this item, it matches the package size.
   }).filter(Boolean)

    var calculatedProductsForProductsView = Object.values(calculatedProductsForProductsPreflight.reduce((acc, { unitsRequiredDefault, actualUnitsRequiredDefault, ...r }) => {
        var key = r.productName + r.unitForDisplayOnly;
        acc[key] = (acc[key] || { ...r, actualUnitsRequiredDefault: 0, unitsRequiredDefault: 0 });
        return (acc[key].actualUnitsRequiredDefault += actualUnitsRequiredDefault, acc[key].unitsRequiredDefault += unitsRequiredDefault, acc);
    }, {}));

   const initializeNumberOfLayers = () => {
      let numberOfLayers = []
      // Determine the total number of resinous layers. Push each layerNumber to a storage array, numberOfLayers, for reference.
      calculatedProductsForLayersView.map(cp => {
         return numberOfLayers.push(cp.layerNumber)
      })
      // Set a new array of the number of layers, removing duplicates.
      let setNumberofLayers = [...new Set(numberOfLayers)]
      // Sort numberOfLayers so rendering of data is in order, with Layer 1 first, on top.
      return setNumberofLayers.sort()
   }


   // Handle "Add to Cart" button click.
    const handleAddToCart = (values) => {
        setAddToCartError(false)

        var arr = [];
        Object.keys(values).forEach(function (key) {
            if (values[key]) {
                arr.push(key);
            }
        });
        
      // Prepare the data from the form of items selected to add to cart
      const productNamesSkusQuantitiesRaw = arr
      let productNamesSkusQuantities = productNamesSkusQuantitiesRaw.map(p => {
         return p.split(',')
      })

       let productSkus = productNamesSkusQuantities.map(p => p[0])
        let productQuantities = productNamesSkusQuantities.map(p => p[1])

      let uomsArray = productNamesSkusQuantities.map(p => "EA")

      let dataForCart = {
         "Items":[...productSkus],
         "UOMs":[...uomsArray],
         "Quantities":[...productQuantities], 
         "ItemNumberIsShortItemNumber":false
      }

       productSkus = []
       productQuantities = []
       uomsArray = []

       function callCart(dataForCart) {
       //Clear the cart
      $.ajax({
         type: "POST",
         dataType: "json",
         xhrFields: { withCredentials: true },
         url: "https://my.laticrete.com/ECO/Services/scShoppingProcess/ClearShoppingCart",
         success: function(data) {
            // const message = "Success! Shopping cart is now cleared."
            // const type = "success"
            // toastNotify(message, type)
         },
         error: function(xhr, error) {
            setAddToCartError("There was a problem adding to cart.")
            const message = "Error. Shopping cart could not be cleared."
            const type = "error"
            toastNotify(message, type)
         }
      }).done(function () {
         // Send product data object to the cart
         $.ajax({
            type: "POST",
            dataType: "json",
            xhrFields: { withCredentials: true },
            data: dataForCart,
            url: "https://my.laticrete.com/ECO/Services/scShoppingProcess/AddItemsToCart",
            success: function() {
               const message = "Success! Cart has been updated with new items."
               const type = "success"
               toastNotify(message, type)
            },
            error: function() {
               setAddToCartError("There was a problem adding to cart.")
               const message = "Error. Items could not be added to cart."
               const type = "error"
               toastNotify(message, type)
            }
         }).done(function (response) {
            const message = "Items added to cart. Redirecting to my.laticrete.com."
            const type = "success"
            toastNotify(message, type)
            window.location.href = "https://my.laticrete.com/shopping-cart";
         })
         }).fail(function () {
            setAddToCartError("There was a problem adding to cart.")
         })
      }

      // Ensure product(s) are selected then send to cart. If not, throw error.
      Object.values(values).includes(true) ? (
         callCart(dataForCart)
         // SAMPLE DATA STRUCTURE
         // {
         //     "Items":["9140-0002-2","9302-0055-2","9236-0001-22","9811-0005-2","9807-0005-2"],
         //     "UOMs":["EA","EA","EA","EA","EA"],
         //     "Quantities":["5","4","2","2","2"],
         //    "ItemNumberIsShortItemNumber":false
         // }
      ) : (
         setAddToCartError("No products selected. Please select products.")
      )
   }

    let topCoatOnlyNotExtraAddOn = []

    if (extraTopCoat) {
        topCoatOnlyNotExtraAddOn = calculatedProductsForLayersView.filter(t => t.addOnExtraTopCoat === 'yes').map(c => c.requiredAmount).reduce((a, b) => a + b, 0);
    } else {
        topCoatOnlyNotExtraAddOn = calculatedProductsForLayersView.filter(t => t.isTopCoat === 'yes' && t.addOnExtraTopCoat === 'no').map(c => c.requiredAmount).reduce((a, b) => a + b, 0);
    }

    if (tractionAdditive !== 'None' && topCoatOnlyNotExtraAddOn <= 0 && clinicalPlus == true) {
        topCoatOnlyNotExtraAddOn = calculatedProductsForLayersView.filter(t => t.addOnClinicalPlus === 'yes').map(c => c.requiredAmount).reduce((a, b) => a + b, 0);
    }

    useEffect(() => {
        tractionAdditive !== 'None' && calculateTractionAdditive(topCoatOnlyNotExtraAddOn)
    }, [calculatedProductsRaw])


   // Calculate Traction Additive
    async function calculateTractionAdditive(gals) {
      const { resinousTractionAdditivesEndpoint } = config
        const apiCompleteUrl = resinousTractionAdditivesEndpoint + "/" + bu + "/" + iso + "/" + gals

      // Fetch the calculated products and information for the quote based on the URL parameters.
    
      let apiResponse = await axios.get(apiCompleteUrl)
         .then(res => {
             setTractionAdditiveData(res.data)
             console.log(res.data)
            return res.data
         })
         .catch(err => {
            console.log(err.status)
         })
         return apiResponse
   }


   // If a traction additive was selected by user, and api response is good:
   // Set selected traction additive product into "Supplies" data tables:
   const selectedTractionAdditiveArray = tractionAdditiveData && tractionAdditiveData.map(ta => {
      return ta.name===tractionAdditive && ta
   }).filter(Boolean)
   // Set selectedTractionAdditive to first and only [0] array item, to remove the wrapping array.
   const selectedTractionAdditive = selectedTractionAdditiveArray && selectedTractionAdditiveArray[0]
   const productType = productOptionsSelected.productOptions[1]
   const systemName = productOptionsSelected.productOptions[3].toLowerCase()
   const iconCartPlus = <FontAwesomeIcon icon={ faCartPlus } color="#00a8d5" />
    const sortedNumberOfLayers = initializeNumberOfLayers()

   // const { Name:chipName, Coverage:chipCoverage, UnitsRequired:chipUnitsRequired, ActualUnitsRequired:chipActualUnitsRequired } = parseChipCoverageData()
   // const imageFileRegex = /~[a-z0-9./~]*ashx/ // Finds substring like "~/media/27e897d07dfc4802b40e6e0b9e9ee876.ashx"

   return (
      <div className="data-table-wrapper">
         <div className="col-xs-12">
               <h3 className="quote-heading">Coverage Details <span className="small">(<strong>Preferred Packaging Size:</strong> {preferredPackagingSize})</span></h3>
            <div className="data-table">
               <div className="row hidden-xs">
                  <div className="col-xs-12 col-sm-3">Total Area</div>
                  { systemName.indexOf('moisture') === -1 && <div className="col-xs-12 col-sm-3">Vapor Barrier</div> }
                  <div className="col-xs-12 col-sm-3">Substrate Preparation</div>
                  { selectedChip && <div className="col-xs-12 col-sm-3">Chip Selection</div> }
               </div>
               <div className="row p-1">
                  <div className="col-xs-12 col-sm-3">
                     <div className="row p-1">
                        <div className="col-xs-6 visible-xs">
                           <strong>Total Area: </strong>
                        </div>
                        <div className="col-xs-6 col-sm-12">
                        { totalArea.toLocaleString('en') }{ unit==="sqft" ? " ft\u00B2" : " m\u00B2" }
                        </div>
                     </div>
                  </div>
                  { systemName.indexOf('moisture') === -1 && <div className="col-xs-12 col-sm-3">
                     <div className="row p-1">
                        <div className="col-xs-6 visible-xs">
                           <strong>Vapor Barrier: </strong>
                        </div>
                        <div className="col-xs-6 col-sm-12">
                        { vaporBarrier ? vaporBarrier : "None" }
                        </div>
                     </div>
                  </div>
                  }
                  <div className="col-xs-12 col-sm-3">
                     <div className="row p-1">
                        <div className="col-xs-6 visible-xs">
                           <strong>Substrate Preparation: </strong>
                        </div>
                        <div className="col-xs-6 col-sm-12">
                        { substratePreparation ? substratePreparation : "None" }
                        </div>
                     </div>
                  </div>
                  { selectedChip && 
                  <div className="col-xs-12 col-sm-3">
                     <div className="row p-1">
                        <div className="col-xs-6 visible-xs">
                           <strong>Chip Selection: </strong>
                        </div>
                        <div className="col-xs-6 col-sm-12">
                        { selectedChip }
                        </div>
                     </div>
                  </div>
                  }
               </div>
            </div>
            <div className="data-table">
               <div className="row hidden-xs">
                  { selectedColor && <div className="col-xs-12 col-sm-3">Color</div> }
                  { systemName.indexOf('moisture') === -1 &&
                  <React.Fragment>
                     <div className="col-xs-12 col-sm-3">Extra Top Coat</div>
                     <div className="col-xs-12 col-sm-3">Clinical Plus</div>
                     <div className="col-xs-12 col-sm-3">Traction Additive</div>
                  </React.Fragment>
                  }
               </div>
               <div className="row p-1">
                  { selectedColor &&
                  <div className="col-xs-12 col-sm-3">
                     <div className="row p-1">
                        <div className="col-xs-6 visible-xs">
                           <strong>Selected Color:</strong>
                        </div>
                        <div className="col-xs-6 col-sm-12">
                           { selectedColor }
                        </div>
                     </div>
                  </div> }
                  { systemName.indexOf('moisture') === -1 && 
                  <React.Fragment>
                     <div className="col-xs-12 col-sm-3">
                        <div className="row p-1">
                           <div className="col-xs-6 visible-xs">
                              <strong>Extra Top Coat: </strong>
                           </div>
                           <div className="col-xs-6 col-sm-12">
                              { extraTopCoat ? "Yes" : "No" }
                           </div>
                        </div>
                     </div>
                     <div className="col-xs-12 col-sm-3">
                        <div className="row p-1">
                           <div className="col-xs-6 visible-xs">
                              <strong>Clinical Plus: </strong>
                           </div>
                           <div className="col-xs-6 col-sm-12">
                           { clinicalPlus ? "Yes" : "No" }
                           </div>
                        </div>
                     </div>
                     <div className="col-xs-12 col-sm-3">
                        <div className="row p-1">
                           <div className="col-xs-6 visible-xs">
                              <strong>Traction Additive: </strong>
                           </div>
                           <div className="col-xs-6 col-sm-12">
                           { tractionAdditive }
                           </div>
                        </div>
                     </div>
                  </React.Fragment>
                  }
               </div>
            </div>
            
         </div>
         <div className="col-xs-12">
            <hr />
         </div>
         <div className="col-xs-12">
            <h3 className="quote-heading">Supplies</h3>
            {  calculatedProductsRaw.length===0 ? (
               <Loading type="products required" />
            ) : (
            <React.Fragment>
               {
               // Moisture Mitigation system only has one layer. Does not need layer representation. Hide all instances of "BY LAYER" UI panel.
               systemName.indexOf('moisture')===-1 &&
                  <ul className="nav nav-pills nav-justified resinous-supplies-toggle hidden-print">
                     <li className="active"><a data-bs-toggle="pill" href="#by-product">VIEW BY PRODUCT</a></li>
                     <li><a data-bs-toggle="pill" href="#by-layer">VIEW BY LAYER</a></li>
                  </ul>
               }
               <div className="tab-content"> 
                  <div id="by-product" className="tab-pane fade in active">
                                   <Formik initialValues={{}} onSubmit={(values) => { handleAddToCart(values) }} >
                     {
                     props => (
                        <Form>
                           <div className="data-table">
                              <div className="row hidden-xs">
                                 <div className="col-xs-12 col-sm-2">Item/Sku #</div>
                                 <div className="col-xs-12 col-sm-2">Product Name</div>
                                 <div className="col-xs-12 col-sm-2">Unit Size</div>
                                     <div className="col-xs-12 col-sm-2">Required Units</div>
                                 <div className="col-xs-12 col-sm-2 hidden-print">Add to Cart</div>
                              </div>
                              { // FIRST DETERMINE IF A TRACTION ADDITIVE HAS BEEN SELECTED. IF SO, RENDER THAT PRODUCT ROW FIRST.
                              selectedTractionAdditive && (
                              <div className="row p-1">
                                 <div className="col-xs-12 col-sm-2">
                                    <div className="row p-1">
                                       <div className="col-xs-6 visible-xs">
                                          <strong>Item/Sku #:</strong>
                                       </div>
                                       <div className="col-xs-6 col-sm-12">
                                       { selectedTractionAdditive.sku }
                                       </div>
                                    </div>
                                 </div>
                                 <div className="col-xs-12 col-sm-2">
                                    <div className="row p-1">
                                       <div className="col-xs-6 visible-xs">
                                          <strong>Product Name:</strong>
                                       </div>
                                       <div className="col-xs-6 col-sm-12">
                                       { selectedTractionAdditive.name }
                                       </div>
                                    </div>
                                 </div>
                                 {/* <td className="text-center">[Image pending]</div> */}
                                 <div className="col-xs-12 col-sm-2">
                                    <div className="row p-1">
                                       <div className="col-xs-6 visible-xs">
                                          <strong>Unit Size:</strong>
                                       </div>
                                       <div className="col-xs-6 col-sm-12">
                                       { selectedTractionAdditive.unitCount.toFixed(2) + " " + selectedTractionAdditive.unit }
                                       </div>
                                    </div>
                                 </div>
                                 <div className="col-xs-12 col-sm-2">
                                    <div className="row p-1">
                                       <div className="col-xs-6 visible-xs">
                                          <strong>Required Units:</strong>
                                       </div>
                                       <div className="col-xs-6 col-sm-12">
                                       { selectedTractionAdditive.unitsRequired }
                                       </div>
                                    </div>
                                             </div>
                                             { selectedTractionAdditive.isSoldOnline == "true" &&
                                                 <div className="col-xs-12 col-sm-2 hidden-print">
                                                     <div className="row p-1">
                                                         <div className="col-xs-6 visible-xs">
                                                             <strong>Add to Cart:</strong>
                                                         </div>
                                                         <div className="col-xs-6 col-sm-12">
                                                             <CustomToggleShoppingCart
                                                                 name={[selectedTractionAdditive.sku, selectedTractionAdditive.unitsRequired]}
                                                             />
                                                         </div>
                                                     </div>
                                                 </div>
                                             }
                              </div>
                              )}
                                 {
                              // Create a table row for each product.
                              calculatedProductsForProductsView.map((cp, index) => {
                                    return (
                                    // BEGIN PRODUCT ROW
                                    <div className="row" key={ cp.layerNumber+cp.productName+index }>
                                       <div className="col-xs-12 col-sm-2">
                                          <div className="row p-1">
                                             <div className="col-xs-6 visible-xs">
                                                <strong>Item/Sku #:</strong>
                                             </div>
                                                    <div className="col-xs-6 col-sm-12">
                                                        {(cp.colors && colorSku && cp.theseAreChipColors == "false" && cp.theseAreQuartzColors == "false" && cp.isPigmentKit == "false") && !(cp.unitForDisplayOnly == "SMALL" && preferredPackagingSize == "Large")     &&                                                    
                                                             colorSku
                                                        }
                                                        {(cp.colors && colorSku && cp.theseAreChipColors == "false" && cp.theseAreQuartzColors == "false" && cp.isPigmentKit == "false" && (cp.unitForDisplayOnly == "SMALL" && preferredPackagingSize == "Large")) &&
                                                            smallColorSku
                                                        }
                                                        {(cp.colors && colorChipSku && (cp.theseAreChipColors == "true" || cp.theseAreQuartzColors == "true")) &&
                                                            colorChipSku
                                                        }
                                                        {(!cp.colors || cp.isPigmentKit == "true") &&
                                                            cp.sku
                                                        }
                                             </div>
                                          </div>
                                       </div>
                                       <div className="col-xs-12 col-sm-2">
                                          <div className="row p-1">
                                             <div className="col-xs-6 visible-xs">
                                                <strong>Product Name:</strong>
                                             </div>
                                             <div className="col-xs-6 col-sm-12">
                                             { // "PRODUCT NAME"
                                                cp.productName || "Product name missing"
                                             }
                                             </div>
                                          </div>
                                       </div>
                                       <div className="col-xs-12 col-sm-2">
                                          <div className="row p-1">
                                             <div className="col-xs-6 visible-xs">
                                                <strong>Unit Size:</strong>
                                             </div>
                                             <div className="col-xs-6 col-sm-12">
                                             { // "UNIT SIZE"
                                                cp.isPigmentForPigmentKit==="true" ? (
                                                   "Part of kit"
                                                ) : (
                                                   cp.unitForDisplayOnly || `${cp.unitCount} ${cp.unit}`
                                                )
                                             }
                                             </div>
                                          </div>
                                       </div>
                                       <div className="col-xs-12 col-sm-2">
                                          <div className="row p-1">
                                             <div className="col-xs-6 visible-xs">
                                                <strong>Required Units:</strong>
                                             </div>
                                             <div className="col-xs-6 col-sm-12">
                                                        
                                                        {(() => {
                                                            //SPARTACOTE Urethane Cement SL uses chip on 2 layers, so ignore override
                                                            if (cp.theseAreChipColors == "true") {
                                                                var chips = JSON.parse(cp.colors);
                                                                var chip = chips.map(c => {
                                                                    return (c.Name.indexOf(selectedChip) > -1) && c.UnitsRequired
                                                                }).filter(Boolean);
                                                                if (systemName == "SPARTACOTE Urethane Cement SL") {
                                                                    return chip * 2;
                                                                }
                                                                return chip;
                                                            } else if (cp.colors && colorSku && cp.theseAreChipColors == "false" && cp.theseAreQuartzColors == "false" && preferredPackagingSize == "Large" && cp.addOnMvb == "yes") {
                                                                if (cp.unitForDisplayOnly.toLowerCase() == "small") {
                                                                    return mvbKitCoverage[0].unitsRequiredDefault * 2
                                                                } else {
                                                                    return mvbKitCoverage[0].unitsRequiredDefault
                                                                }
                                                            }else {
                                                                return cp.unitsRequiredDefault
                                                            }
                                                        }
                                                        )()}
                                             </div>
                                          </div>
                                            </div>
                                            { cp.isSoldOnline == "true" &&
                                       <div className="col-xs-12 col-sm-2 hidden-print">
                                          <div className="row p-1">
                                             <div className="col-xs-6 visible-xs">
                                                <strong>Add to cart:</strong>
                                             </div>
                                                    <div className="col-xs-6 col-sm-12">
                                                        {(cp.colors && colorSku && cp.theseAreChipColors == "false" && cp.theseAreQuartzColors == "false" && cp.isPigmentKit == "false") && !(cp.unitForDisplayOnly == "SMALL" && preferredPackagingSize == "Large") &&
                                                            <CustomToggleShoppingCart
                                                                name={
                                                                    [colorSku, cp.unitsRequiredDefault]
                                                                }
                                                            />
                                                        }
                                                        {(cp.colors && colorSku && cp.theseAreChipColors == "false" && cp.theseAreQuartzColors == "false" && cp.isPigmentKit == "false" && (cp.unitForDisplayOnly == "SMALL" && preferredPackagingSize == "Large")) &&
                                                            <CustomToggleShoppingCart
                                                                name={
                                                                    [smallColorSku, cp.unitsRequiredDefault]
                                                                }
                                                            />
                                                        }
                                                        {(cp.colors && colorChipSku && (cp.theseAreChipColors == "true" || cp.theseAreQuartzColors == "true")) &&
                                                            <CustomToggleShoppingCart
                                                                name={
                                                                    [colorChipSku, cp.unitsRequiredDefault]
                                                                }
                                                            />
                                                        }
                                                        {(!cp.colors || cp.isPigmentKit == "true") &&
                                                            <CustomToggleShoppingCart
                                                                name={
                                                                    [cp.sku, cp.unitsRequiredDefault]
                                                                }
                                                            />
                                                        }
                                             </div>
                                          </div>
                                            </div>
                                            }
                                    </div>       
                                    )
                                 })
                              }
                           </div>
                           <div className="row hidden-print">
                              <div className="col-xs-12 col-sm-4 col-sm-push-8 col-lg-3 col-lg-push-9">
                                 {
                                    // productsSelected.length > 0 ? (
                                       <button type="submit" className="btn btn-primary btn-lg btn-block btn-add-to-cart" data-bs-toggle="modal" data-bs-target="#modal-addToCart" >{ iconCartPlus } ADD TO CART</button>
                                    // ) : (
                                       // <button type="submit" className="btn btn-primary btn-lg btn-block btn-add-to-cart" disabled>{ iconCartPlus } SELECT PRODUCTS</button>
                                    // )
                                 }
                              </div>
                              <QuoteActionLinks productType={ productType } />
                           </div>
                        </Form>
                     )}
                     </Formik>
                  </div>
               {
               // ***************** Table by layers ***************** //

               // Moisture Mitigation system only has one layer. Does not need layer representation. Hide all instances of "BY LAYER" UI panel.
               systemName.indexOf('moisture')===-1 &&
                  <div id="by-layer" className="tab-pane fade">
                  {
                     sortedNumberOfLayers.map((n, index) => {
                     return (
                     <div key={ 'layer-table-' + n } >
                        <h4>
                           <strong>{ `Layer ${ index + 1 }` }</strong>
                        </h4>
                        <p><strong>Thickness: { [...new Set(calculatedProductsForLayersView.map(cp => cp.layerNumber===n && cp.thickness).filter(Boolean))] }</strong></p>
                        <div className="data-table" key={ n + "_" + index }>
                           <div className="row hidden-xs">
                              <div className="col-xs-12 col-sm-3">Item/Sku #</div>
                              <div className="col-xs-12 col-sm-3">Product Name</div>
                              <div className="col-xs-12 col-sm-3">Coverage</div>
                              <div className="col-xs-12 col-sm-3">Required Amount</div>
                           </div>
                     {
                     // Create a table row for each product assigned to this layer.
                     calculatedProductsForLayersView.map(cp => {
                     return (
                        cp.layerNumber===n && (
                             <div className="row" key={n + "-" + cp.sku + cp.unitForDisplayOnly }>
                              <div className="col-xs-12 col-sm-3">
                                 <div className="row p-1">
                                    <div className="col-xs-6 visible-xs">
                                       <strong>Item/Sku #: </strong>
                                    </div>
                                    <div className="col-xs-6 col-sm-12">
                                             {(cp.colors && colorSku && cp.theseAreChipColors == "false" && cp.theseAreQuartzColors == "false" && cp.isPigmentKit == "false") && !(cp.unitForDisplayOnly == "SMALL" && preferredPackagingSize == "Large") &&
                                                 colorSku
                                             }
                                             {(cp.colors && colorSku && cp.theseAreChipColors == "false" && cp.theseAreQuartzColors == "false" && cp.isPigmentKit == "false" && (cp.unitForDisplayOnly == "SMALL" && preferredPackagingSize == "Large")) &&
                                                 smallColorSku
                                             }
                                             {(cp.colors && colorChipSku && (cp.theseAreChipColors == "true" || cp.theseAreQuartzColors == "true")) &&
                                                 colorChipSku
                                             }
                                             {(!cp.colors || cp.isPigmentKit == "true") &&
                                                 cp.sku
                                             }
                                    </div>
                                 </div>
                              </div>
                              <div className="col-xs-12 col-sm-3">
                                 <div className="row p-1">
                                    <div className="col-xs-6 visible-xs">
                                       <strong>Product Name: </strong>
                                    </div>
                                    <div className="col-xs-6 col-sm-12">
                                    { 
                                       // "Product Name"
                                       cp.productName || "Product name missing"
                                    }
                                    </div>
                                 </div>
                              </div>
                              {/* <td className="text-center">
                                 {
                                    // Product image
                                    cp.productImage.match(imageFileRegex) ?
                                    <a target="_blank" href={ "https://cdn.laticrete.com/"+cp.productImage.match(imageFileRegex) }>
                                          <img style={{ maxWidth:80, maxHeight: 60 }} src={ "https://cdn.laticrete.com/"+cp.productImage.match(imageFileRegex) } alt=" " />
                                    </a> : "Not available"
                                    }
                              </div> */}
                              
                              <div className="col-xs-12 col-sm-3">
                                 <div className="row p-1">
                                    <div className="col-xs-6 visible-xs">
                                       <strong>Coverage: </strong>
                                    </div>
                                         <div className="col-xs-6 col-sm-12">
                                             {(cp.colors && colorSku && cp.theseAreChipColors == "false" && colorCoverage != 0) &&
                                                 colorCoverage
                                             }
                                             {/*{(cp.colors && colorSku && cp.theseAreChipColors == "false" && colorCoverage == 0 && (!(cp.colors && colorSku && cp.theseAreChipColors == "false" && cp.theseAreQuartzColors == "false" && cp.isPigmentKit == "false" && (cp.unitForDisplayOnly == "SMALL" && preferredPackagingSize == "Large")))) &&*/}
                                             {/*    cp.coverage*/}
                                             {/*}*/}
                                             {(cp.colors && colorSku && cp.theseAreChipColors == "false" && colorCoverage == 0 && cp.isPigmentKit == "false" && (!(preferredPackagingSize == "Large" && cp.addOnMvb == "yes"))) &&
                                                 cp.coverage
                                             }
                                             {(cp.colors && colorChipSku && cp.theseAreChipColors == "true") &&
                                                 colorChipCoverage
                                             }
                                             {!cp.colors &&
                                                 cp.coverage
                                             }
                                             {
                                                 (cp.colors && colorSku && cp.theseAreChipColors == "false" && cp.theseAreQuartzColors == "false" && preferredPackagingSize == "Large" && cp.addOnMvb == "yes") &&

                                                 mvbKitCoverage[0].coverage

                                             }
                                             {(cp.theseAreQuartzColors == "true" && cp.addOnMvb == "yes") &&
                                                 cp.coverage
                                             }
                                             {
                                                 (cp.theseAreChipColors == "false" && cp.theseAreQuartzColors == "false" && cp.colors) &&
                                                 (
                                                     unit === "sqft" ? (
                                                         ` ft\u00B2/${cp.unit}`
                                                     ) : (
                                                         ` m\u00B2/${cp.unit}`
                                                     )
                                                 )
                                             }
                                             {
                                                 (cp.theseAreChipColors == "false" && cp.theseAreQuartzColors == "false" && !cp.colors) &&
                                                 (
                                                     unit === "sqft" ? (
                                                         " ft\u00B2/gal"
                                                     ) : (
                                                             " m\u00B2/L"
                                                         )
                                                 )
                                             }
                                             {
                                                 (cp.colors && colorChipSku && (cp.theseAreChipColors == "true" || cp.theseAreQuartzColors == "true")) &&
                                                 (unit === "sqft" ? (
                                                 " ft\u00B2/lb"
                                             ) : (
                                                 " m\u00B2/kg"
                                                 )
                                                     )
                                             }
                                             
                                    </div>
                                 </div>
                                 </div>
                                 <div className="col-xs-12 col-sm-3">
                                     <div className="row p-1">
                                         <div className="col-xs-6 visible-xs">
                                             <strong>Required Amount #: </strong>
                                         </div>
                                         <div className="col-xs-6 col-sm-12">
                                                 {(() => {
                                                 if (cp.theseAreChipColors == "true") {
                                                     var chips = JSON.parse(cp.colors);

                                                     var chip = chips.map(c => {
                                                         return (c.Name.indexOf(selectedChip) > -1) && c.RequiredAmount
                                                     }).filter(Boolean);
                                                     return chip;
                                                 } else if (cp.colors && colorSku && cp.theseAreChipColors == "false" && cp.theseAreQuartzColors == "false" && preferredPackagingSize == "Large" && cp.addOnMvb == "yes") {
                                                     if (cp.unitForDisplayOnly.toLowerCase() == "small") {
                                                         
                                                         return largeColorRequiredAmount * 2
                                                     } else {
                                                         return cp.requiredAmount
                                                     }
                                                 } else {
                                                     return cp.requiredAmount
                                                 }
                                             }
                                             )()}


                                             {
                                                 (unit === "mm" && cp.unit === "gal" || cp.unit === "qt") ?
                                                     " L" :
                                                     (cp.unit === "lb" && unit === "mm") ? " kg"
                                                         : (cp.unit === "lb" && unit === "mm") ? " kg"
                                                             : ` ${cp.unit}`
                                             }
                                         </div>
                                     </div>
                                 </div>
                           </div>
                           ))})}
                           {
                           // If a traction additive was selected and the index of this item is equal to the length of the array-1 (arrays start at 0), render the traction additive product here in the last row of the "first" layer.
                           (selectedTractionAdditive && index===sortedNumberOfLayers.length-1) && (
                           <div className="row" key={ selectedTractionAdditive.name+ "_" + n }>
                              <div className="col-xs-12 col-sm-3">
                                 <div className="row p-1">
                                    <div className="col-xs-6 visible-xs">
                                       <strong>Item/Sku #: </strong>
                                    </div>
                                    <div className="col-xs-6 col-sm-12">
                                    { selectedTractionAdditive.sku }
                                    </div>
                                 </div>
                              </div>
                              <div className="col-xs-12 col-sm-3">
                                 <div className="row p-1">
                                    <div className="col-xs-6 visible-xs">
                                       <strong>Product Name: </strong>
                                    </div>
                                    <div className="col-xs-6 col-sm-12">
                                    { selectedTractionAdditive.name }
                                    </div>
                                 </div>
                              </div>
                                             <div className="col-xs-12 col-sm-3">
                                                 <div className="row p-1">
                                                     <div className="col-xs-6 visible-xs">
                                                         <strong>Coverage: </strong>
                                                     </div>
                                                     <div className="col-xs-6 col-sm-12">
                                                         {selectedTractionAdditive.unitsPerGallonOfTopCoat + " " + selectedTractionAdditive.unit + " / gal of top coat"}
                                                     </div>
                                                 </div>
                                             </div>
                              <div className="col-xs-12 col-sm-3">
                                 <div className="row p-1">
                                    <div className="col-xs-6 visible-xs">
                                       <strong>Required Amount: </strong>
                                    </div>
                                                     <div className="col-xs-6 col-sm-12">
                                                         {selectedTractionAdditive.requiredAmount + " " + selectedTractionAdditive.unit }
                                    </div>
                                 </div>
                              </div>
                              
                           </div>
                           )
                        }
                        </div>
                     </div>
                     )})}
                  </div>
               }
               </div>
            </React.Fragment>
            )
         }
      <QuoteModals />
      <ResinousAddToCartModal error={ addToCartError } />
      </div>
   </div>
   )
}


// WEBPACK FOOTER //
// ./src/components/productTypes/resinous/ResinousQuoteCreated.js